import { defineMessage } from 'react-intl';

import { NavigationBar, Page } from '@ocx/ui';
import { ProfileButton } from '../../components/Layout/NavigationBar/ProfileButton/ProfileButton';
import { StoreLocatorButton } from '../../components/Layout/NavigationBar/StoreLocatorButton/StoreLocatorButton';
import { VendorLogo } from '../../components/Layout/NavigationBar/VendorLogo/VendorLogo';
import { HtmlTitle } from '../../components/router/HtmlTitle';
import type { ReactNode } from 'react';

export type HomeLayoutProps = {
  children: ReactNode;
};

export const HomeLayout = ({ children }: HomeLayoutProps) => {
  return (
    <Page>
      <HtmlTitle
        title={defineMessage({
          id: 'home:htmlTitle',
          defaultMessage: 'Home',
          description: 'HTML title tag for Home Page',
        })}
      />
      <NavigationBar left={<StoreLocatorButton />} center={<VendorLogo />} right={<ProfileButton />} />
      {children}
    </Page>
  );
};
